<template lang="pug">
  #BackgroundDownload(v-if="openByLiff")
    .text-center.mb-3
      h5.mb-0 限定手機桌布下載
      .mt-2.mb-0.mx-3(style="font-size: 0.8rem") 請點選下方桌布樣式，可長按圖片並儲存完成
      button.btn.btn-primary.mt-2(
        type="button",
        @click="backToLINEHandler()"
      ) 返回官方帳號
    .wallpaperArea.position-relative.d-flex.align-items-center.w-100(style='padding: 0 35px;')
      //img.h-100(v-show="imageIndex !== 1" style="width: 10%; height:auto" :src="require(`@/assets/images/makePicture/leftClick.png`)" @click="changeImageIndex(-1)")
      //div.arrow.prev(v-show="imageIndex !== 1")
      //div(v-show="imageIndex === 1" style="")
      .div
        template(v-if="isAndroid")
          a(
            v-for="(image, index) in wallPaper" 
            :key="index" 
            v-show="imageIndex === index + 1" 
            :href="image" 
            download="wallpaper.jpeg" 
            style="width: 100%; height: 100%;"
          )
            img.img-fluid.w-100#previewWallPaper(
              width="80%" 
              v-show="imageIndex === index + 1" 
              :src="image"
            )
        div(v-else)
          img.img-fluid.w-100#previewWallPaper(
            width="80%"
            v-for="(image, index) in wallPaper"
            :key="index"
            v-show="imageIndex === index + 1"
            :src="image"
          )

      .arrow-absolute
        div.arrow.prev(v-show="imageIndex !== 1" @click="changeImageIndex(-1)")
        div.arrow.next(v-show="imageIndex !== wallPaper.length" @click="changeImageIndex(+1)")
</template>

<script>
import backgroundImgUrl from '@/assets/images/bg/backgroundImg.jpg';
import wallpaper1 from '@/assets/images/bg/wallpaper1.jpg';

export default {
  name: 'BackgroundDownloadIndexAndroid',
  data() {
    return {
      backgroundImg: backgroundImgUrl,
      imageIndex: 1,
      isAndroid: false,
      openByLiff: false,
      wallPaper: [
        'https://gcs-tiffany.skridea.com/1655167316/backend/el7OWaQAVX.jpeg',
        'https://gcs-tiffany.skridea.com/1655167316/backend/IDZdubPDuv.jpeg',
        'https://gcs-tiffany.skridea.com/1655167316/backend/gQU92yP0Bo.jpeg',
        'https://gcs-tiffany.skridea.com/1655167316/backend/0voH9f4ix2.jpeg',
        'https://gcs-tiffany.skridea.com/1655167316/backend/CdChJyDdoM.jpeg'
      ]
    };
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.redirectToLiff) {
      window.location.href = process.env.VUE_APP_WALLPAPER_LIFF_URL;
    } else {
      vm.openByLiff = true;
    }
  },
  created() {
    const vm = this;
    // 檢查綁定狀態
    vm.$store.dispatch('member_bind_sa/checkMemberBindHandler')
      .then((res) => {
        vm.$store.dispatch('member_make_picture/sendClickRecordHandler', { line_uuid: res.line_uuid, desktop_no: 0 });
        if (res.type === 'not_binding') {
          vm.$router.push({
            name: 'm-sign-up'
          })
        } else {
          vm.line_uuid = res.line_uuid;

          let u = navigator.userAgent;
          vm.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
        }

        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    // 切換桌布
    changeImageIndex(num) {
      const vm = this;
      vm.imageIndex += num;
    },
    downloadHandler() {
      let image = new Image();
      image.src = backgroundImgUrl;
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL();
        var a = document.createElement('a');
        a.href = base64;
        a.download = '';
        a.click();
			};
      image.setAttribute('crossOrigin', 'Anonymous');
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
  }
};
</script>

<style scoped>
  .arrow-absoulte {
    width: 100%;
    height: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    margin-top: 0;
    margin: auto;
  }
  .arrow {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 20px;
    background: transparent;
  }

  .prev {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 20px;
    height: 50px;
    left: 8px;
    background: transparent;
    color: #FFF;
    font-size: 14px;
    display: inline-block;
    cursor: pointer;
    border-radius: 3px;
  }
  .prev::before {
    top: -20px;
    -webkit-transform: rotate(
            -60deg);
    transform: rotate(
            -60deg);
    content: '';
    display: block;
    width: 25px;
    height: 2px;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000000;
    margin: auto;
  }
  .prev::after {
    bottom: -20px;
    -webkit-transform: rotate(
            60deg);
    transform: rotate(
            60deg);
    content: '';
    display: block;
    width: 25px;
    height: 2px;
    position: absolute;
    top: 0;
    right: 10px;
    left: 0;
    background-color: #000000;
    margin: auto;
  }
  .next {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 20px;
    height: 50px;
    right: 8px;
    background: transparent;
    color: #FFF;
    font-size: 14px;
    display: inline-block;
    cursor: pointer;
    border-radius: 3px;
  }
  .next::before {
    top: -20px;
    -webkit-transform: rotate(
            60deg);
    transform: rotate(
            60deg);
    content: '';
    display: block;
    width: 25px;
    height: 2px;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000000;
    margin: auto;
  }
  .next::after {
    bottom: -20px;
    -webkit-transform: rotate(
            -60deg);
    transform: rotate(
            -60deg);
    content: '';
    display: block;
    width: 25px;
    height: 2px;
    position: absolute;
    top: 0;
    right: 10px;
    left: 0;
    background-color: #000000;
    margin: auto;
  }

</style>
